module.exports = __webpack_public_path__ + "static/TNM079___Modeling_And_Animation__Lab_6-92dd108c0d8f930fecad65364aa59bd5.pdf";